import { BasePlate, BasePlateHeader } from '@evrone-erp/uikit';
import { ReadOnlyInput } from '@widgets/credentials/readonly-credentials-plate/ui/ReadOnlyInput';
import { useTranslation } from 'next-i18next';
import React, { memo } from 'react';
import type { IGeneralProps } from '@widgets/general/lib/types';
const basePlateSx = {
  height: '100%'
};
export const General = memo(({
  name = '',
  surname = '',
  onClick,
  isLoading
}: IGeneralProps) => {
  const {
    t
  } = useTranslation('account');
  const value = name ? `${name} ${surname}` : surname;
  return <BasePlate loading={isLoading} pressable sx={basePlateSx} onClick={onClick}>
      <BasePlateHeader title={t('general')} />
      {value && <ReadOnlyInput type="text" id="full-name-input" label={t('fullName')} value={value} />}
    </BasePlate>;
});
General.displayName = 'General';